module.exports = __webpack_public_path__ + "static/media/ic_dustbin_disabled.945138cd.svg";